export const calcLongShortRatio = (props) => {
    const totalCount = props.longCount + props.shortCount + props.flatCount;
    const longShortRatio = totalCount === 0 ? 0 : (props.longCount - props.shortCount) / totalCount;
    return longShortRatio;
};
